var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-container",
    { staticClass: "cd-container cd-equipment" },
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { xs: "12", sm: "12", md: "12", lg: "12", xl: "12" } },
            [
              _c("StylizedRadioGroup", {
                attrs: {
                  options: _vm.categories,
                  preSelection: _vm.selectedCategory
                },
                model: {
                  value: _vm.selectedCategory,
                  callback: function($$v) {
                    _vm.selectedCategory = $$v
                  },
                  expression: "selectedCategory"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "b-row",
        { staticClass: "cd-equipment-cards" },
        _vm._l(_vm.currentCategoryEquipment, function(e) {
          return _c(
            "b-col",
            {
              key: e.id,
              staticClass: "p-2 ",
              attrs: { cols: "12", sm: "6", md: "6", lg: "3", xl: "3" }
            },
            [
              _c(
                "b-card",
                {
                  class: e.selected
                    ? "cd-box-component cd-box-color equipment selected"
                    : e.disabled
                    ? "cd-box-component cd-box-color equipment disabled"
                    : "cd-box-component cd-box-color equipment",
                  on: {
                    click: function($event) {
                      return _vm.toggleEquipment(e)
                    }
                  }
                },
                [
                  _c("b-card-text", [
                    _c(
                      "p",
                      { staticClass: "cd-equipment-label cd-primary-black" },
                      [_vm._v(" " + _vm._s(e.label) + " ")]
                    ),
                    e.price_gross
                      ? _c(
                          "p",
                          {
                            staticClass:
                              "cd-equipment-price-info cd-primary-grey"
                          },
                          [
                            _vm._v(
                              " + " +
                                _vm._s(
                                  _vm._f("formatCurrency")(e.price_gross)
                                ) +
                                " € "
                            )
                          ]
                        )
                      : _vm._e(),
                    e.description && e.description.length > 0
                      ? _c(
                          "a",
                          {
                            attrs: { href: "#" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.showEquipmentInfos(e)
                              }
                            }
                          },
                          [_vm._v("Mehr erfahren")]
                        )
                      : _vm._e()
                  ])
                ],
                1
              )
            ],
            1
          )
        }),
        1
      ),
      _c("b-modal", {
        attrs: {
          static: "",
          scrollable: "",
          id: "cd-equipmentinfo-modal",
          size: "lg",
          title: ""
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              return [
                _c(
                  "b-container",
                  [
                    _c("h5", { staticClass: "cd-headline" }, [
                      _vm._v("Sonderausstattung")
                    ]),
                    _c("p", { staticClass: "cd-subline cd-primary-black" }, [
                      _vm._v(" " + _vm._s(_vm.currentEquipment.label) + " ")
                    ]),
                    _c("b-col", [
                      _c(
                        "ul",
                        { staticClass: "cd-equipment-info-list" },
                        _vm._l(_vm.currentEquipment.description, function(
                          d,
                          i
                        ) {
                          return _c("li", { key: i }, [
                            _vm._v(" " + _vm._s(d) + " ")
                          ])
                        }),
                        0
                      )
                    ])
                  ],
                  1
                )
              ]
            }
          },
          {
            key: "modal-footer",
            fn: function(ref) {
              var ok = ref.ok
              return [
                _c(
                  "b-button",
                  {
                    staticClass: "cd-button",
                    attrs: { size: "sm" },
                    on: {
                      click: function($event) {
                        return ok()
                      }
                    }
                  },
                  [_vm._v("Hinzufügen")]
                )
              ]
            }
          }
        ])
      }),
      _c(
        "b-row",
        { staticClass: "p-4 d-flex justify-content-center" },
        [
          _c(
            "b-col",
            { attrs: { sm: "12", md: "10", lg: "8", xl: "6" } },
            [
              _c(
                "b-button",
                {
                  staticClass: "cd-button cd-std-button cd-next-button",
                  attrs: { size: "sm" },
                  on: {
                    click: function($event) {
                      return _vm.saveCarConfiguration()
                    }
                  }
                },
                [_vm._v("Konfiguration abschließen")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "b-modal",
        {
          attrs: {
            static: "",
            scrollable: "",
            size: "s",
            id: "cd-equipment-modal",
            title: "Achtung"
          },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function(ref) {
                var ok = ref.ok
                return [
                  _c(
                    "b-button",
                    {
                      staticClass: "cd-button",
                      attrs: { size: "sm" },
                      on: {
                        click: function($event) {
                          return ok()
                        }
                      }
                    },
                    [_vm._v("Schliessen")]
                  )
                ]
              }
            }
          ])
        },
        [_c("p", [_vm._v("Bitte wählen Sie eine Farbe.")])]
      ),
      _c("b-modal", {
        attrs: {
          static: "",
          scrollable: "",
          id: "cd-equipment-selection",
          size: "lg",
          title: 'Bitte wählen und "Hinzufügen"'
        },
        on: { ok: _vm.shouldSelectExtra, hide: _vm.onCancelExtraSelection },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              return [
                _c(
                  "b-container",
                  [
                    _c("RequirementsTree", {
                      attrs: {
                        level: 0,
                        node: _vm.requirements,
                        checkRequirements: _vm.checkRequirements
                      }
                    })
                  ],
                  1
                )
              ]
            }
          },
          {
            key: "modal-footer",
            fn: function(ref) {
              var ok = ref.ok
              return [
                _c(
                  "b-button",
                  {
                    staticClass: "cd-button",
                    attrs: { size: "sm" },
                    on: {
                      click: function($event) {
                        return ok()
                      }
                    }
                  },
                  [_vm._v("Hinzufügen")]
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }